// ID Ð·Ð°Ð²Ð¾Ð´Ð° Ñ Ð±Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÐ¼Ð¸
export const USED_CAR_FACTORY_ID = 36;

// ÐÐ¾ÑÑÐ´Ð¾Ðº Ð·Ð°Ð²Ð¾Ð´Ð¾Ð² Ð² Ð²ÑÐ¿Ð°Ð´Ð°ÑÑÐµÐ¼ ÑÐ¿Ð¸ÑÐºÐµ (Ð¿ÐµÑÐµÑÐ¸ÑÐ»ÐµÐ½Ð½ÑÐµ Ð¸Ð´ÑÑ Ð¿ÐµÑÐ²ÑÐ¼Ð¸, Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ â ÐºÐ°Ðº Ñ Ð±ÑÐºÐµÐ½Ð´Ð°)
export const FACTORY_ORDER_PRIORITY = ['Ð¡ÐÐ', 'AMQ'];

// Ð¢Ð¸Ð¿Ñ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹
export const CAR_ORIGIN_TYPES = {
  NEW_KZ: 1,                    // ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð¿ÑÐ¾Ð¸Ð·Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ Ð² ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ðµ
  NEW_IMPORT: 2,            // ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð²Ð²ÐµÐ·ÑÐ½Ð½Ð¾Ðµ
  PURCHASE: 3,                // ÐÑÐºÑÐ¿ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
  PLEDGED_PURCHASE: 4, // ÐÑÐºÑÐ¿ Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾
  EXCHANGE: 5,                // ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¼ÐµÐ½Ñ
  CONSIGNMENT: 6,          // ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ
  CONSIGNMENT_FIRST_REG: 7, // ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ
};

// ÐÐ¿Ð¸ÑÐ°Ð½Ð¸Ñ ÑÐ¸Ð¿Ð¾Ð² Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ
export const CAR_ORIGIN_LABELS = {
  [CAR_ORIGIN_TYPES.NEW_KZ]: 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð¿ÑÐ¾Ð¸Ð·Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ Ð² ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ðµ',
  [CAR_ORIGIN_TYPES.NEW_IMPORT]: 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð²Ð²ÐµÐ·ÑÐ½Ð½Ð¾Ðµ',
  [CAR_ORIGIN_TYPES.PURCHASE]: 'ÐÑÐºÑÐ¿ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'ÐÑÐºÑÐ¿ Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¼ÐµÐ½Ñ',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ',
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: 'ÐÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ',
};

// ÐÐ¾ÑÑÑÐµÐ½Ð¸Ðµ: 6 â Ð¾Ð±ÑÑÐ½Ð¾Ðµ, 7 â Ñ Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¹ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸ÐµÐ¹ (Ð±Ð°Ð½ÐºÐ°Ð¼ ÑÑÐ¾Ð´Ð¸Ñ ÐµÑ Ð¿ÑÐ¸Ð·Ð½Ð°Ðº)
export const CONSIGNMENT_ORIGINS = [CAR_ORIGIN_TYPES.CONSIGNMENT, CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG];
export const isConsignmentOrigin = (origin) => CONSIGNMENT_ORIGINS.includes(origin);

// Ð¢Ð¸Ð¿Ñ, ÑÑÐµÐ±ÑÑÑÐ¸Ðµ Ð¿ÑÐ¾ÑÐµÑÑ Ð²ÑÐºÑÐ¿Ð°
export const PURCHASE_PROCESS_TYPES = [
  CAR_ORIGIN_TYPES.PURCHASE,
  CAR_ORIGIN_TYPES.PLEDGED_PURCHASE,
  CAR_ORIGIN_TYPES.EXCHANGE,
  ...CONSIGNMENT_ORIGINS,
];

// Ð¢Ð¸Ð¿Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð²ÑÐºÑÐ¿Ð°
export const PURCHASE_DOCUMENT_TYPES = {
  PURCHASE_CONTRACT: 'purchase_contract',       // ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð²ÑÐºÑÐ¿Ð°
  INSPECTION_ACT: 'inspection_act',            // ÐÐºÑ Ð¿ÑÐ¸ÑÐ¼ÐºÐ¸/Ð¾ÑÐ¼Ð¾ÑÑÐ°
  CAR_PHOTOS: 'car_photos',                    // Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ
  SIGNED_CONTRACT: 'signed_contract',          // ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð½ÑÐ¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ
};

// Ð¢Ð¸Ð¿Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¾Ð² Ð¿Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ
export const CONTRACT_TYPES_BY_ORIGIN = {
  [CAR_ORIGIN_TYPES.PURCHASE]: 'purchase',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'pledged_purchase',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'exchange',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'consignment',
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: 'consignment',
};

// Ð¡ÑÐ°ÑÑÑÑ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐ¸ Ð²ÑÐºÑÐ¿Ð°
export const PURCHASE_STATUS = {
  PENDING: 'pending',           // Ð Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐµ
  DOCUMENTS_UPLOADED: 'docs_uploaded', // ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ
  CONTRACT_GENERATED: 'contract_generated', // ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°Ð½
  CONTRACT_SIGNED: 'contract_signed', // ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½
  COMPLETED: 'completed',       // ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¾
  CANCELLED: 'cancelled',       // ÐÑÐ¼ÐµÐ½ÐµÐ½Ð¾
};

// Ð¢ÑÐµÐ±ÑÐµÐ¼ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ¸Ð¿Ð°
export const REQUIRED_DOCUMENTS_BY_TYPE = {
  [CAR_ORIGIN_TYPES.PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.EXCHANGE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
}; 